import { render } from "./AccountingBankImportTable.vue?vue&type=template&id=507b240a&scoped=true&ts=true&lang=pug"
import script from "./AccountingBankImportTable.vue?vue&type=script&lang=ts"
export * from "./AccountingBankImportTable.vue?vue&type=script&lang=ts"

import "./AccountingBankImportTable.vue?vue&type=style&index=0&id=507b240a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b240a"]])

export default __exports__